import { ProjectRecord, ProjectDocument } from '@/lib/projects/project-types';
export type { SourceRunStatus } from '@/lib/sources/source-types';
export { SECTORS } from '@/lib/reference-data/sectors';
export { sources, sourceRunStatuses } from '@/lib/reference-data/sources';

function doc(id: string, title: string, url: string, type: ProjectDocument['type'], source?: string): ProjectDocument {
  return { id, title, url, type, source };
}

function daysAgo(n: number): string {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString();
}



export const projects: ProjectRecord[] = [
  {
    id: 'proj-001',
    organizationName: 'GIZ',
    projectName: 'Soil Protection and Rehabilitation for Food Security',
    startDate: '2014-11-21T00:00:00.000Z',
    endDate: '2027-04-30T00:00:00.000Z',
    executiveSummary:
      "The world is losing fertile soil at an alarming rate, with annual degradation now equivalent to roughly one-third of Germany's land area. This trend poses serious threats to global food security and climate stability. The most affected regions are arid and semi-arid areas of Asia, Africa, and Latin America, where livelihoods depend heavily on agriculture. For smallholder farmers, declining soil fertility directly undermines food production and income. Fertile soil is also the second-largest carbon sink after the oceans, making it critical for climate protection. Ecologically sustainable soil management approaches are therefore essential to restore soil health, strengthen resilience, and support long-term food and climate security.",
    projectLink: 'https://www.giz.de/de/projekte/bodenschutz-und-bodenrehabilitierung-fuer-ernaehrungssicherung',
    callForProposalLink: 'https://capacity4dev.europa.eu/projects/desira/info/prosilience_en',
    country: ['Benin', 'Burkina Faso', 'Ethiopia', 'Kenya', 'India', 'Madagascar', 'Tunisia'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'giz.de',
    updatedAt: '2026-02-26T10:22:00.000Z',
    organizationType: 'Government Organization',
    inCooperation: '',
    euCountry: 'Germany',
    documents: [
      doc(
        'doc-proj-001-01',
        'PROSILIENCE English',
        'https://capacity4dev.europa.eu/media/125064/download/29f29841-4d05-4bef-8703-37a0a8b4394f_en',
        'pdf'
      ),
    ],
  },
  {
    id: 'proj-002',
    organizationName: 'GIZ',
    projectName: 'Climate protection and adaptation to climate change in Kenya',
    startDate: '2024-05-01T00:00:00.000Z',
    endDate: '2027-04-30T00:00:00.000Z',
    executiveSummary:
      'Climate change mitigation and adaptation in Kenya Supporting Climate Strategies and NDC Implementation at District Level',
    projectLink: 'https://www.giz.de/de/projekte/foerderung-von-klimastrategien-und-ndc-umsetzung-auf-distriktebene',
    callForProposalLink: 'https://www.giz.de/de/projekte/foerderung-von-klimastrategien-und-ndc-umsetzung-auf-distriktebene',
    country: ['Kenya'],
    sector: 'Agriculture and fishing',
    productGroup: 'fish-seafood',
    sourceDomain: 'giz.de',
    updatedAt: '2026-02-26T10:22:00.000Z',
    organizationType: 'Government Organization',
    inCooperation:
      'BMZ, Ministry of Information, Communications and the Digital Economy (Kenia), Ministry of Environment and Forestry (MoEF)',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-003',
    organizationName: 'GIZ',
    projectName: 'Youth Employment in the agri-food sector in Western Kenya',
    startDate: '2024-01-01T00:00:00.000Z',
    endDate: '2026-12-31T00:00:00.000Z',
    executiveSummary:
      'Rural youth in Western Kenya are benefiting from sustainable income and employment opportunities in the agrifood-sector in Western Kenya.',
    projectLink: 'https://www.giz.de/de/projekte/jugendbeschaeftigung-der-agrar-und-ernaehrungswirtschaft-im-westen-kenias-0',
    callForProposalLink: 'https://www.giz.de/de/projekte/jugendbeschaeftigung-der-agrar-und-ernaehrungswirtschaft-im-westen-kenias-0',
    country: ['Kenya'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'giz.de',
    updatedAt: '2026-02-26T10:22:00.000Z',
    organizationType: 'Government Organization',
    inCooperation: 'Ministry of Agriculture and Livestock Development',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-004',
    organizationName: 'GIZ',
    projectName: 'Soil Matters — Innovations for Soil Health and Agroecology',
    startDate: '2025-01-01T00:00:00.000Z',
    endDate: '2029-04-30T00:00:00.000Z',
    executiveSummary: 'New approaches to healthy soil and sustainable farming are successfully disseminated in select partner countries.',
    projectLink: 'https://www.giz.de/de/projekte/soil-matters-innovationen-fuer-bodengesundheit-und-agraroekologie',
    callForProposalLink: 'https://www.giz.de/de/projekte/soil-matters-innovationen-fuer-bodengesundheit-und-agraroekologie',
    country: ['Ethiopia', 'Kenya', 'India', 'Madagascar', 'Tunisia', 'Nigeria', 'Cameroon'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'giz.de',
    updatedAt: '2026-02-26T10:22:00.000Z',
    organizationType: 'Government Organization',
    inCooperation: 'Bundesministerium für wirtschaftliche Zusammenarbeit und Entwicklung (BMZ)',
    euCountry: 'Germany',
    documents: [
      doc(
        'doc-proj-004-01',
        'Soil Protection and Rehabilitation (GIZ 2025, EN)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-09/giz2025-en-factsheet-pr.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-004-02',
        'Soil protection – a trigger for the transformation towards sustainable agricultural and food systems (GIZ 2025, EN)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-09/giz2025-en-factsheet-tafs.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-004-03',
        'Implementing agroecology through soil protection (GIZ 2025, EN)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-09/giz2025-en-factsheet-asp.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-004-04',
        'Soil protection and reduction of greenhouse gas emissions (GIZ 2025, EN)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-09/giz2025-en-factsheet-rgge.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-004-05',
        'Gender in Soil Matters: Comparative Insights from Multi-Country Gender Analyses (GIZ 2025, EN)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-09/giz-2025-en-gender-soil-matters.pdf',
        'pdf'
      ),
    ],
  },
  {
    id: 'proj-005',
    organizationName: 'GIZ',
    projectName: 'Working together for efficient and inclusive trade',
    startDate: '2024-07-01T00:00:00.000Z',
    endDate: '2027-12-31T00:00:00.000Z',
    executiveSummary:
      'In the participating countries, measures have been established that facilitate trade and protect the climate and environment.',
    projectLink: 'https://www.giz.de/de/projekte/globalvorhaben-partnerschaften-fuer-nachhaltigen-handel',
    callForProposalLink: 'https://www.giz.de/de/projekte/globalvorhaben-partnerschaften-fuer-nachhaltigen-handel',
    country: ['Kenya', 'Morocco', 'Mauritania', 'Ukraine', 'Bosnia and Herzegovina', 'Cambodia'],
    sector: 'Economic Development, Climate Change',
    productGroup: 'fresh-produce',
    sourceDomain: 'giz.de',
    updatedAt: '2026-02-26T10:22:00.000Z',
    organizationType: 'Government Organization',
    inCooperation: '',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-006',
    organizationName: 'GIZ',
    projectName: "Women's Empowerment for Resilient Rural Areas (WE4R)",
    startDate: '2024-01-01T00:00:00.000Z',
    endDate: '2028-12-31T00:00:00.000Z',
    executiveSummary:
      'The rights, resources and representation of women in rural areas are strengthened with regard to the sustainable use of land resources.',
    projectLink: 'https://www.giz.de/de/projekte/globalvorhaben-staerkung-von-frauen-fuer-resiliente-laendliche-raeume',
    callForProposalLink: 'https://www.giz.de/de/projekte/globalvorhaben-staerkung-von-frauen-fuer-resiliente-laendliche-raeume',
    country: ['Kenya', 'Madagascar', 'Mali'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'giz.de',
    updatedAt: '2026-02-26T10:22:00.000Z',
    organizationType: 'Government Organization',
    inCooperation: 'Bundesministerium für wirtschaftliche Zusammenarbeit und Entwicklung (BMZ)',
    euCountry: 'Germany',
    documents: [
      doc(
        'doc-proj-006-01',
        'Stärkung von Frauen für Resiliente Ländliche Räume (GIZ 2025, DE)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2026-02/giz2025-de-we4r-frauen-laendliche-raeume.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-006-02',
        'Women’s Empowerment for Resilient Rural Areas (GIZ 2025, EN)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2026-02/giz2025-en-we4r-women-rural-areas.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-006-03',
        'Renforcer les femmes pour des zones rurales résilientes (GIZ 2025, FR)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2026-02/giz2025-fr-we4r-femmes-zones-rurales.pdf',
        'pdf'
      ),
    ],
  },
  {
    id: 'proj-007',
    organizationName: 'GIZ',
    projectName: 'Promoting Agriculture through Innovation (Green Innovation Centres)',
    startDate: '2014-10-01T00:00:00.000Z',
    endDate: '2026-09-30T00:00:00.000Z',
    executiveSummary:
      'Promoting innovations in agri-food chains to strengthen income, employment and climate adaptation in rural regions.',
    projectLink: 'https://www.giz.de/de/projekte/globalvorhaben-gruene-innovationszentren-der-agrar-und-ernaehrungswirtschaft-giae',
    callForProposalLink: 'https://www.giz.de/de/projekte/globalvorhaben-gruene-innovationszentren-der-agrar-und-ernaehrungswirtschaft-giae',
    country: [
      'Benin',
      'Burkina Faso',
      'Cameroon',
      "Côte d'Ivoire",
      'Ethiopia',
      'Ghana',
      'India',
      'Kenya',
      'Malawi',
      'Mali',
      'Mozambique',
      'Nigeria',
      'Togo',
      'Tunisia',
      'Viet Nam',
      'Zambia',
    ],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'giz.de',
    updatedAt: '2026-02-26T10:22:00.000Z',
    organizationType: 'Government Organization',
    inCooperation: 'Partner Ministries',
    euCountry: 'Germany',
    documents: [
      doc(
        'doc-proj-007-01',
        'Burkina Faso: Grüne Innovationszentren in der Agrar- und Ernährungswirtschaft (GIAE) (GIZ 2023, DE)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-07/giz2023-de-factsheet-prociv.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-007-02',
        'Burkina Faso: Green Innovation Centres for the Agri-Food Sector (ProCIV) (GIZ 2023, EN)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-07/giz2023-en-factsheet-prociv.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-007-03',
        'Burkina Faso : Centres d’Innovations Vertes dans le secteur agro-alimentaire (ProCIV) (GIZ 2023, FR)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-07/giz2023-fr-factsheet-prociv.pdf',
        'pdf'
      ),
    ],
  },
  {
    id: 'proj-008',
    organizationName: 'GIZ',
    projectName: 'Promoting Digital Agricultural Innovations in Africa (SAIS)',
    startDate: '2024-07-01T00:00:00.000Z',
    endDate: '2027-12-31T00:00:00.000Z',
    executiveSummary:
      'The SAIS project strengthens African agri-food start-ups so their digital innovations can scale, attract investors and reach more farmers.',
    projectLink: 'https://www.giz.de/de/projekte/globalvorhaben-partnerschaften-fuer-nachhaltigen-handel',
    callForProposalLink: 'https://www.giz.de/de/projekte/globalvorhaben-partnerschaften-fuer-nachhaltigen-handel',
    country: ['Bosnia and Herzegovina', 'Cambodia', 'Kenya', 'Mauritania', 'Morocco', 'Ukraine'],
    sector: 'IT outsourcing / digital services & products (software, BPO, digital solutions)',
    productGroup: 'digital-services',
    sourceDomain: 'giz.de',
    updatedAt: '2026-02-26T10:22:00.000Z',
    organizationType: 'Government Organization',
    inCooperation: '',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-009',
    organizationName: 'GIZ',
    projectName: 'Global Programme Digital Transformation',
    startDate: '2019-02-06T00:00:00.000Z',
    endDate: '2027-03-31T00:00:00.000Z',
    executiveSummary:
      'Supporting partner countries worldwide in shaping digitalisation in a fair, secure and sustainable way — driving progress in economy, society and environment.',
    projectLink: 'https://www.giz.de/de/projekte/globalvorhaben-digitale-transformation',
    callForProposalLink: 'https://www.bmz-digital.global/',
    country: [
      'Cameroon',
      'Chile',
      'Colombia',
      "Côte d'Ivoire",
      'Djibouti',
      'Ecuador',
      'Egypt',
      'Ethiopia'
    ],
    sector: 'Digital & Innovation',
    productGroup: 'digital-services',
    sourceDomain: 'giz.de',
    updatedAt: '2026-02-26T10:22:00.000Z',
    organizationType: 'Government Organization',
    inCooperation: 'Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ) GmbH',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-010',
    organizationName: 'GIZ',
    projectName: 'Supporting Experts and Institutions in Land Policy Advisory in Africa',
    startDate: '2014-11-19T00:00:00.000Z',
    endDate: '2026-02-28T00:00:00.000Z',
    executiveSummary:
      'Strengthening African experts and institutions in land policy advisory so they can better design and implement sustainable land rights for marginalised groups (e.g. smallholder farmers, women, pastoralists).',
    projectLink: 'https://www.giz.de/de/projekte/staerkung-der-beratungskapazitaeten-fuer-landpolitik-afrika',
    callForProposalLink: 'https://www.giz.de/de/projekte/staerkung-der-beratungskapazitaeten-fuer-landpolitik-afrika',
    country: ['Cameroon', 'Ethiopia', 'Ghana', 'Kenya', 'Morocco', 'Namibia', 'Senegal', 'South Africa', 'Tanzania'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'giz.de',
    updatedAt: '2026-02-26T10:22:00.000Z',
    organizationType: 'Government Organization',
    inCooperation: 'Bundesministerium für wirtschaftliche Zusammenarbeit und Entwicklung (BMZ)',
    euCountry: 'Germany',
    documents: [
      doc(
        'doc-proj-010-01',
        'Introduction to NELGA (GIZ 2025)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-07/giz2025-en-land-governance-africa-nelga-factsheet.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-010-02',
        'Présentation du NELGA (GIZ 2025)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-07/giz2025-fr-land-governance-africa-nelga-factsheet.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-010-03',
        'Network of Excellence on Land Governance in Africa (GIZ 2025)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-09/giz2025-en-land-governance-africa-nelga-brochure.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-010-04',
        "Réseau d'excellence sur la gouvernance foncière en Afrique (NELGA) (GIZ 2025)",
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-07/giz2025-fr-land-governance-africa-nelga-brochure.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-010-05',
        'Strengthening Advisory Capacities for Land Governance in Africa (SLGA) (GIZ 2025)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-07/giz2025-en-advisory-capacities-land-governance-africa-slga.pdf',
        'pdf'
      ),
      doc(
        'doc-proj-010-06',
        'Renforcement des Capacités de Conseil sur la Gouvernance Foncière en Afrique (SLGA) (GIZ 2025)',
        'https://www.giz.de/sites/default/files/media/pkb-document/2025-07/giz2025-fr-advisory-capacities-land-governance-africa-slga.pdf',
        'pdf'
      ),
    ],
  },
  {
    id: 'proj-011',
    organizationName: 'KfW',
    projectName: 'Flourishing growth: How Selecta One is modernizing its production in Kenya with DEG',
    startDate: '2014-01-01T00:00:00.000Z',
    endDate: '',
    executiveSummary: 'Financing modern, sustainable production facilities for ornamental and food plants, promoting environmentally friendly growth, local employment and social standards.',
    projectLink: 'https://www.kfw.de/%C3%9Cber-die-KfW/Newsroom/Aktuelles/Mittelstand-st%C3%A4rken/Selecta-One.html',
    callForProposalLink: 'https://www.kfw.de/%C3%9Cber-die-KfW/Newsroom/Aktuelles/Mittelstand-st%C3%A4rken/Selecta-One.html',
    country: ['Kenya'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'kfw.de',
    updatedAt: daysAgo(20),
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-012',
    organizationName: 'KfW',
    projectName: 'Kenya a pioneer in green energy',
    startDate: '2018-01-01T00:00:00.000Z',
    endDate: '2030-12-31T00:00:00.000Z',
    executiveSummary: 'KfW supports Kenya in expanding renewable energy sources such as geothermal, wind and solar to sustainably improve electricity supply.',
    projectLink: 'https://www.kfw.de/stories/umwelt/erneuerbare-energien/kenia-gruene-energie/',
    callForProposalLink: 'https://www.kfw-entwicklungsbank.de/SDG-Portal/SDG-7/index.html',
    country: ['Kenya'],
    sector: 'Climate & Environment',
    productGroup: 'digital-services',
    sourceDomain: 'kfw.de',
    updatedAt: daysAgo(22),
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-013',
    organizationName: 'KfW',
    projectName: 'Better Prospects for Youth in Kenya (VIVA Programme)',
    startDate: '2022-01-01T00:00:00.000Z',
    endDate: '',
    executiveSummary: 'Das VIVA‑Programm verbessert in kenianischen Armenvierteln die Perspektiven junger Menschen (15–24 Jahre), indem es gesundheitliche Aufklärung, Familienplanung, sportliche Freizeitangebote und Berufsbildung kombiniert',
    projectLink: 'https://www.kfw-entwicklungsbank.de/SDG-Portal/SDG-3/VIVA-Kenia/',
    callForProposalLink: 'https://www.kfw-entwicklungsbank.de/SDG-Portal/SDG-3/VIVA-Kenia/',
    country: ['Kenya'],
    sector: 'Economic Development',
    productGroup: 'digital-services',
    sourceDomain: 'kfw-entwicklungsbank.de',
    updatedAt: daysAgo(24),
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-014',
    organizationName: 'KfW',
    projectName: 'Growth Driver from Kenya — Selecta One Cuttings',
    startDate: '1999-01-01T00:00:00.000Z',
    endDate: '',
    executiveSummary: 'Selecta One has operated large greenhouses for cuttings in Kenya since 1999, sustainably modernising them with DEG financing while promoting energy efficiency and social standards.',
    projectLink: 'https://www.kfw.de/stories/kfw/stories/wirtschaft/unternehmen/stecklinge-aus-kenia-von-selecta-one/',
    callForProposalLink: 'https://www.kfw.de/stories/kfw/stories/wirtschaft/unternehmen/stecklinge-aus-kenia-von-selecta-one/',
    country: ['Kenya'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'kfw.de',
    updatedAt: daysAgo(26),
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-015',
    organizationName: 'KfW',
    projectName: 'Biodiversity Safety Net in Tanzania',
    startDate: '2021-01-01T00:00:00.000Z',
    endDate: '',
    executiveSummary: 'Supporting Tanzania in stabilising key national parks (Serengeti, Nyerere, Selous) during the COVID crisis by covering operating costs, providing equipment and promoting sustainable tourism.',
    projectLink: 'https://www.kfw-entwicklungsbank.de/ipfz/Projektdatenbank/Rettungsschirm-f%C3%BCr-Biodiversit%C3%A4t-in-Tansania-49385.htm',
    callForProposalLink: 'https://www.kfw-entwicklungsbank.de/ipfz/Projektdatenbank/Rettungsschirm-f%C3%BCr-Biodiversit%C3%A4t-in-Tansania-49385.htm',
    country: ['Tanzania'],
    sector: 'Climate & Environment',
    productGroup: 'tourism',
    sourceDomain: 'kfw-entwicklungsbank.de',
    updatedAt: daysAgo(28),
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-016',
    organizationName: 'KfW',
    projectName: 'Simiyu Climate Resilience Project in Tanzania',
    startDate: '2019-01-01T00:00:00.000Z',
    endDate: '2025-01-01T00:00:00.000Z',
    executiveSummary: 'Strengthens climate resilience through expansion of water supply, sanitation infrastructure and climate-adapted agriculture.',
    projectLink: 'https://www.kfw.de/stories/umwelt/klimaschutz/klimaschutz-tansania/',
    callForProposalLink: 'https://www.kfw.de/stories/umwelt/klimaschutz/klimaschutz-tansania/',
    country: ['Tanzania'],
    sector: 'Climate & Environment',
    productGroup: 'fresh-produce',
    sourceDomain: 'kfw.de',
    updatedAt: daysAgo(30),
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-017',
    organizationName: 'KfW',
    projectName: 'Power Supply North-West Tanzania',
    startDate: '',
    endDate: '',
    executiveSummary: 'Verbesserung der Stromversorgung im Nordwesten Tansanias durch den Ausbau einer Übertragungsleitung, was regionale Netz‑Integration (z. B. mit Burundi, Ruanda, Uganda) und den Anschluss von Wasserkraftwerken ermöglicht',
    projectLink: 'https://www.kfw-entwicklungsbank.de/ipfz/Projektdatenbank/Stromversorgung-Nord-West-Tansania-30240.htm',
    callForProposalLink: 'https://www.kfw-entwicklungsbank.de/ipfz/Projektdatenbank/Stromversorgung-Nord-West-Tansania-30240.htm',
    country: ['Tanzania'],
    sector: 'Climate & Environment',
    productGroup: 'digital-services',
    sourceDomain: 'kfw-entwicklungsbank.de',
    updatedAt: daysAgo(32),
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-018',
    organizationName: 'KfW',
    projectName: 'When Drought Persists: KfW Helps Tanzania Mitigate Climate Change Impacts',
    startDate: '2017-01-01T00:00:00.000Z',
    endDate: '2025-12-31T00:00:00.000Z',
    executiveSummary: 'Climate adaptation project in the Simiyu region to improve water supply, sanitation and climate-adapted agriculture for greater resilience against drought.',
    projectLink: 'https://www.kfw.de/%C3%9Cber-die-KfW/Newsroom/Aktuelles/Pressemitteilungen-Details_520384.html',
    callForProposalLink: 'https://www.kfw.de/%C3%9Cber-die-KfW/Newsroom/Aktuelles/Pressemitteilungen-Details_520384.html',
    country: ['Tanzania'],
    sector: 'Climate & Environment',
    productGroup: 'fresh-produce',
    sourceDomain: 'kfw.de',
    updatedAt: daysAgo(34),
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-019',
    organizationName: 'KfW',
    projectName: 'Ethiopia\'s Economic Transformation',
    startDate: '2025-01-01T00:00:00.000Z',
    endDate: '2025-12-31T00:00:00.000Z',
    executiveSummary: 'KfW supports Ethiopia with financing for transport infrastructure (railway, freight terminal), economic transformation and vocational training, helping the country advance to middle-income status by 2025.',
    projectLink: 'https://www.kfw.de/stories/wirtschaft/infrastruktur/aufbruch-in-aethiopien/',
    callForProposalLink: 'https://www.kfw.de/stories/wirtschaft/infrastruktur/aufbruch-in-aethiopien/',
    country: ['Ethiopia'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'kfw.de',
    updatedAt: daysAgo(36),
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-020',
    organizationName: 'KfW',
    projectName: 'Investing in Practical Vocational Training for the Future (Ethiopia)',
    startDate: '2002-01-01T00:00:00.000Z',
    endDate: '',
    executiveSummary: 'Promoting practical vocational training in Ethiopia by modernising vocational schools, linking them with businesses and aligning them with labour market needs.',
    projectLink: 'https://www.kfw-entwicklungsbank.de/Weltweit/Subsahara-Afrika/PI-Berufsbildung-%C3%84thiopien/',
    callForProposalLink: 'https://www.kfw-entwicklungsbank.de/Weltweit/Subsahara-Afrika/PI-Berufsbildung-%C3%84thiopien/',
    country: ['Ethiopia'],
    sector: 'Economic Development',
    productGroup: 'digital-services',
    sourceDomain: 'kfw-entwicklungsbank.de',
    updatedAt: daysAgo(38),
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-021',
    organizationName: 'KfW',
    projectName: 'Using knowledge to combat erosion',
    startDate: '2010-01-01T00:00:00.000Z',
    endDate: '',
    executiveSummary:
      'Supporting Ethiopian farmers in halting soil erosion, restoring watersheds and thereby sustainably stabilising their agriculture.',
    projectLink: 'https://www.kfw.de/stories/umwelt/natuerliche-ressourcen/aethiopien-landwirtschaft/',
    callForProposalLink: 'https://www.kfw.de/stories/umwelt/natuerliche-ressourcen/aethiopien-landwirtschaft/',
    country: ['Ethiopia'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'kfw.de',
    updatedAt: '2026-02-26T00:00:00.000Z',
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-022',
    organizationName: 'KfW',
    projectName: 'Sustainable Land Management Program',
    startDate: '2009-01-01T00:00:00.000Z',
    endDate: '2023-01-01T00:00:00.000Z',
    executiveSummary: 'Program strengthens land management through soil and water conservation measures in watersheds to combat land degradation and increase rural household incomes.',
    projectLink: 'https://www.kfw-entwicklungsbank.de/ipfz/Projektdatenbank/Programm-Nachhaltige-Landbewirtschaftung-27591.htm',
    callForProposalLink: 'https://www.kfw-entwicklungsbank.de/ipfz/Projektdatenbank/Programm-Nachhaltige-Landbewirtschaftung-27591.htm',
    country: ['Ethiopia'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'kfw-entwicklungsbank.de',
    updatedAt: '2026-02-26T00:00:00.000Z',
    organizationType: 'Developing-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-023',
    organizationName: 'KfW',
    projectName: 'KfW promotes training for medical professionals in Ethiopia',
    startDate: '2020-12-01T00:00:00.000Z',
    endDate: '',
    executiveSummary: 'KfW promotes the training of medical professionals in Ethiopia, particularly in biomedical technology, by equipping vocational schools, teaching hospitals and a Bio-Medical Design Studio, and training teachers.',
    projectLink: 'https://www.kfw-entwicklungsbank.de/%C3%9Cber-uns/News/News-Details_844800.html',
    callForProposalLink: 'https://www.kfw-entwicklungsbank.de/%C3%9Cber-uns/News/News-Details_844800.html',
    country: ['Ethiopia'],
    sector: 'Economic Development',
    productGroup: 'digital-services',
    sourceDomain: 'kfw-entwicklungsbank.de',
    updatedAt: '2026-02-26T00:00:00.000Z',
    organizationType: 'Development-Bank',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-024',
    organizationName: 'sequa gGmbH',
    projectName: 'Skilled Craft Fonds Plus',
    startDate: '2024-03-01T00:00:00.000Z',
    endDate: '2027-12-31T00:00:00.000Z',
    executiveSummary: 'Mobilises German craft expertise in developing and emerging countries through partnerships, networks and knowledge exchange.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/handwerksfonds-plus-1086/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/handwerksfonds-plus-1086/',
    country: ["Afghanistan", "Egypt", "Albania", "Algeria", "Angola", "Argentina", "Armenia", "Azerbaijan", "Ethiopia", "Bangladesh", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Burkina Faso", "Burundi", "China", "Costa Rica", "Ivory Coast", "Democratic Republic of the Congo", "Dominican Republic", "Ecuador", "El Salvador", "Gabon", "Gambia", "Georgia", "Ghana", "Guatemala", "Guinea", "Guinea-Bissau", "Haiti", "Honduras", "India", "Indonesia", "Iraq", "Yemen", "Jordan", "Cambodia", "Cameroon", "Cape Verde", "Kenya",
"Kyrgyzstan", "Colombia", "Republic of the Congo", "Kosovo", "Croatia", "Cuba", "Laos"],
    sector: 'Economic Development',
    productGroup: 'digital-services',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T00:00:00.000Z',
    organizationType: 'Development organisation',
    inCooperation: 'Zentralverband des Deutschen Handwerks (ZDH), Verschiedene HAndwerksorganisationen und Handwerksbetriebe',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-025',
    organizationName: 'sequa gGmbH',
    projectName: 'Machinery Rings in Kenya and Rwanda',
    startDate: '2023-11-01T00:00:00.000Z',
    endDate: '2026-10-31T00:00:00.000Z',
    executiveSummary: 'Machine-sharing networks are being established in Kenya and Rwanda so smallholder farmers can jointly use agricultural machinery and make their production more efficient.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/maschinenringe-in-kenia-und-ruanda-1063/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/maschinenringe-in-kenia-und-ruanda-1063/',
    country: ['Kenya', 'Rwanda'],
    sector: 'Economic Development',
    productGroup: 'fresh-produce',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T00:00:00.000Z',
    organizationType: 'Development organisation',
    inCooperation: null,
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-026',
    organizationName: 'sequa gGmbH',
    projectName: 'VET in Masonry and Welding in Kenya',
    startDate: '2023-01-01T00:00:00.000Z',
    endDate: '2025-12-31T00:00:00.000Z',
    executiveSummary: 'The project enables the Don Bosco Boys Town vocational school in Kenya to offer hands-on training in masonry and welding, and introduces a certification process together with local partners.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/berufsbildung-im-mauern-und-schweissen-in-kenia-1032/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/berufsbildung-im-mauern-und-schweissen-in-kenia-1032/',
    country: ['Kenya'],
    sector: 'Economic Development',
    productGroup: 'digital-services',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T00:00:00.000Z',
    organizationType: 'Development organisation',
    inCooperation: 'Don Bosco Boys Town (DBBT), Kenya Federation of Master Builders (KFMB), National Industrial Training Authority (NITA)',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-027',
    organizationName: 'sequa gGmbH',
    projectName: 'TVET Partnership AVT Zanzibar',
    startDate: '2024-12-15T00:00:00.000Z',
    endDate: '2027-08-14T00:00:00.000Z',
    executiveSummary: 'Strengthening vocational schools in Zanzibar so that trainees can acquire practical skills in water and wastewater technology.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/bbp-avt-sansibar-1127/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/bbp-avt-sansibar-1127/',
    country: ['Tanzania'],
    sector: 'Economic Development',
    productGroup: 'digital-services',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T00:00:00.000Z',
    organizationType: 'Development organisation',
    inCooperation: 'Karume Institute of Science and Technology, Zanzibar Association of Tourism Investors (ZATI)',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-028',
    organizationName: 'sequa gGmbH',
    projectName: 'TVET Partnership AVT Tanzania',
    startDate: '2024-12-15T00:00:00.000Z',
    endDate: '2027-08-14T00:00:00.000Z',
    executiveSummary: 'Strengthening vocational schools in Tanzania so that trainees can acquire practical skills in water and wastewater technology.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/bbp-avt-tansania-1128/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/bbp-avt-tansania-1128/',
    country: ['Tanzania'],
    sector: 'Economic Development',
    productGroup: 'digital-services',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T00:00:00.000Z',
    organizationType: 'Development organisation',
    inCooperation: 'Karume Institute of Science and Technology, Tanzania Association of Tourism Investors (TATI)',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-029',
    organizationName: 'sequa gGmbH',
    projectName: 'Supporting the organic cotton sector in Ethiopia',
    startDate: '2023-10-01T00:00:00.000Z',
    endDate: '2026-12-31T00:00:00.000Z',
    executiveSummary: 'The project strengthens sustainable organic cotton production in Ethiopia and access to international markets.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/unterstuetzung-des-bio-baumwollsektors-in-aethiopien-1059/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/unterstuetzung-des-bio-baumwollsektors-in-aethiopien-1059/',
    country: ['Ethiopia'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T00:00:00.000Z',
    organizationType: 'Development organisation',
    inCooperation: 'Gesamtverband der deutschen Maschenindustrie – Gesamtmasche e.V., Ethiopian Ministry of Agriculture (MoA), Ethiopian Textile and Garment Manufacturers’ Association (ETGAMA)',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-030',
    organizationName: 'sequa gGmbH',
    projectName: 'BBP of the NRW building associations in Ethiopia',
    startDate: '2024-12-15T00:00:00.000Z',
    endDate: '2026-12-14T00:00:00.000Z',
    executiveSummary: 'The project builds practical training in the construction and water sector in Ethiopia, focusing on pipeline/wastewater, women’s empowerment and potential labour migration to Germany.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/bbp-der-bauverbaende-nrw-in-aethiopien-1126/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/bbp-der-bauverbaende-nrw-in-aethiopien-1126/',
    country: ['Ethiopia'],
    sector: 'Economic Development',
    productGroup: 'digital-services',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T00:00:00.000Z',
    organizationType: 'Development organisation',
    inCooperation: 'Amhara Construction Contractors Association (ACCA), Construction Contractors Association of Ethiopia (CCAE), Dire Dawa Construction Contractors Association (DCCA), General Wingate Polytechnic College in Addis Ababa (GWPTC), Oromia Construction Contractors Association (OCCA), South Construction Contractors Association (SCCA)',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-031',
    organizationName: 'sequa gGmbH',
    projectName: 'SME Support Programme Ethiopia',
    startDate: '2022-12-01T00:00:00.000Z',
    endDate: '2026-09-30T00:00:00.000Z',
    executiveSummary: 'Programme supports SMEs in Ethiopia through advisory services, technical training, financial literacy and change management, with a particular focus on improving access to finance.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/kmu-foerderprogramm-aethiopien-1013/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/kmu-foerderprogramm-aethiopien-1013/',
    country: ['Ethiopia'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T14:00:00.000Z',
    organizationType: 'Non profit',
    inCooperation: 'GIZ - Deutsche Gesellschaft für internationale Zusammenarbeit',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-032',
    organizationName: 'sequa gGmbH',
    projectName: 'BIC Ethiopia',
    startDate: '2022-01-03T00:00:00.000Z',
    endDate: '2026-07-02T00:00:00.000Z',
    executiveSummary: 'Strengthens business incubators in Ethiopia so they can better support agri-tech and agri start-ups, seize market opportunities, increase incomes and create new jobs.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/bic-ethiopia-911/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/bic-ethiopia-911/',
    country: ['Ethiopia'],
    sector: 'Agriculture & Food Security',
    productGroup: 'fresh-produce',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T14:00:00.000Z',
    organizationType: '',
    inCooperation: 'adelphi consult GmbH, GrowthAfrica, Menschen für Menschen, Addis Ababa Chamber of Commerce & Sectoral Association (AACCSA) Icehawassa',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-033',
    organizationName: 'sequa gGmbH',
    projectName: 'Skills Development in Ethiopia',
    startDate: '2023-03-16T00:00:00.000Z',
    endDate: '2026-03-15T00:00:00.000Z',
    executiveSummary: 'Strengthens vocational training in Ethiopia’s agri-industry, connects training centres with private companies and improves employment opportunities for youth and women.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/qualifikationsentwicklung-in-aethiopien-1046/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/qualifikationsentwicklung-in-aethiopien-1046/',
    country: ['Ethiopia'],
    sector: 'Economic Development',
    productGroup: 'fresh-produce',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T14:00:00.000Z',
    organizationType: '',
    inCooperation: 'Hamen, Eurecna',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-034',
    organizationName: 'sequa gGmbH',
    projectName: 'Chamber Support in the Amhara Region',
    startDate: '2023-01-01T00:00:00.000Z',
    endDate: '2025-12-31T00:00:00.000Z',
    executiveSummary: 'The project strengthens the Amhara Regional Chamber to network the economy and promote growth.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/kammerunterstuetzung-in-der-amhara-region-1038/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/kammerunterstuetzung-in-der-amhara-region-1038/',
    country: ['Ethiopia'],
    sector: 'Economic Development',
    productGroup: 'digital-services',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T14:00:00.000Z',
    organizationType: '',
    inCooperation: 'Amhara Region Chamber of Commerce and Sectoral Associations (ARCCSA)',
    euCountry: 'Germany',
    documents: [],
  },
  {
    id: 'proj-035',
    organizationName: 'sequa gGmbH',
    projectName: 'Trade Fair Presence of African Companies',
    startDate: '2024-09-15T00:00:00.000Z',
    endDate: '2025-12-14T00:00:00.000Z',
    executiveSummary: 'The project supports African companies in participating in trade fairs in Europe and in B2B matchmaking.',
    projectLink: 'https://www.sequa.de/weltweit/projektdatenbank/messepraesenz-von-afrikanischen-firmen-1103/',
    callForProposalLink: 'https://www.sequa.de/weltweit/projektdatenbank/messepraesenz-von-afrikanischen-firmen-1103/',
    country: ['Ethiopia'],
    sector: 'Economic Development',
    productGroup: 'digital-services',
    sourceDomain: 'sequa.de',
    updatedAt: '2026-02-26T14:00:00.000Z',
    organizationType: '',
    inCooperation: 'GIZ',
    euCountry: 'Germany',
    documents: [],
  },
  {
   "id": "proj-036",
   "organizationName": "CBI",
   "projectName": "Women's Economic Empowerment Kenya",
   "startDate": "2021-01-01T00:00:00.000Z",
   "endDate": "2026-12-31T00:00:00.000Z",
   "executiveSummary": "Strengthens women entrepreneurs in Kenya through better access to finance, markets and support structures, with the goal of promoting business growth, export potential and good jobs for women.",
   "projectLink": "https://www.cbi.eu/projects/womens-economic-empowerment-kenya",
   "callForProposalLink": "https://www.cbi.eu/projects/get-involved/?manager=Renee%20van%20Woerden&destination=/projects/womens-economic-empowerment-kenya",
   "country": ["Kenya"],
   "sector": "Agriculture & Food Security",
   "productGroup": "fresh-produce",
   "sourceDomain": "cbi.eu",
   "updatedAt": "2026-02-26T14:00:00.000Z",
   "organizationType": "",
   "inCooperation": "",
   "euCountry": "Netherlands",
   "documents": []
 },
 {
   "id": "proj-037",
   "organizationName": "CBI",
   "projectName": "Macadamia nuts Kenya",
   "startDate": "2022-01-01T00:00:00.000Z",
   "endDate": "2026-12-31T00:00:00.000Z",
   "executiveSummary": "Strengthens Kenyan macadamia nut processors so they can implement sustainable business practices, improve quality and export their products to the EU market.",
   "projectLink": "https://www.cbi.eu/projects/macadamia-nuts-kenya",
   "callForProposalLink": "https://www.cbi.eu/projects/macadamia-nuts-kenya",
   "country": ["Kenya"],
   "sector": "Agriculture & Food Security",
   "productGroup": "natural-ingredients",
   "sourceDomain": "cbi.eu",
   "updatedAt": "2026-02-26T14:00:00.000Z",
   "organizationType": "",
   "inCooperation": "",
   "euCountry": "Netherlands",
   "documents": []
 },
 {
   "id": "proj-038",
   "organizationName": "CBI",
   "projectName": "Community Tourism Ethiopia",
   "startDate": "2025-01-01T00:00:00.000Z",
   "endDate": "2028-12-31T00:00:00.000Z",
   "executiveSummary": "Promotes sustainable community tourism in Ethiopia by involving local communities in new tourism offerings and connecting them with EU markets.",
   "projectLink": "https://www.cbi.eu/projects/community-tourism-ethiopia",
   "callForProposalLink": "https://www.cbi.eu/projects/ask-question?destination=/projects/community-tourism-ethiopia",
   "country": ["Ethiopia"],
   "sector": "Economic Development",
   "productGroup": "tourism",
   "sourceDomain": "cbi.eu",
   "updatedAt": "2026-02-26T14:00:00.000Z",
   "organizationType": "",
   "inCooperation": "",
   "euCountry": "Netherlands",
   "documents": []
 },
 {
   "id": "proj-039",
   "organizationName": "CBI",
   "projectName": "Fresh Fruit and Vegetables Ethiopia",
   "startDate": "2021-01-01T00:00:00.000Z",
   "endDate": "2025-12-31T00:00:00.000Z",
   "executiveSummary": "Project supports Ethiopian SMEs in the fresh fruit and vegetable sector to export more sustainably, particularly by shifting from air to sea freight, adopting CSR practices and improving export structures.",
   "projectLink": "https://www.cbi.eu/projects/fresh-fruit-and-vegetables-ethiopia",
   "callForProposalLink": "https://www.cbi.eu/projects/ask-question?destination=/projects/fresh-fruit-and-vegetables-ethiopia",
   "country": ["Ethiopia"],
   "sector": "Agriculture & Food Security",
   "productGroup": "fresh-produce",
   "sourceDomain": "cbi.eu",
   "updatedAt": "2026-02-26T14:00:00.000Z",
   "organizationType": "",
   "inCooperation": "Ethiopian Agricultural Authority (EAA)",
   "euCountry": "Netherlands",
   "documents": []
 },
 {
   "id": "proj-040",
   "organizationName": "CBI",
   "projectName": "Spices Ethiopia",
   "startDate": "2021-01-01T00:00:00.000Z",
   "endDate": "2025-12-31T00:00:00.000Z",
   "executiveSummary": "Strengthens Ethiopian spice SMEs so they can produce high-quality, safe spices and successfully export to the EU market.",
   "projectLink": "https://www.cbi.eu/projects/spices-ethiopia",
   "callForProposalLink": "https://www.cbi.eu/projects/ask-question?destination=/projects/spices-ethiopia",
   "country": ["Ethiopia"],
   "sector": "Agriculture & Food Security",
   "productGroup": "natural-ingredients",
   "sourceDomain": "cbi.eu",
   "updatedAt": "2026-02-26T14:00:00.000Z",
   "organizationType": "",
   "inCooperation": "Ethiopian Spice Sector Association (ESSA), Ethiopian Chamber of Commerce and Sectoral Associations, Ethiopian Coffee and Tea Authority (ECTA), Centre for Accelerated Women's Economic Empowerment (CAWEE), Tepi Agricultural Research Centre, TradEthiopia, GiZ",
   "euCountry": "Netherlands",
   "documents": []
 }

];

export const SIMULATE = Object.freeze({
  mode: 'ok' as 'ok' | 'partialFailure' | 'hardError' | 'empty',
  loadingMs: 600,
});



